import styled from 'styled-components';

const RequestClaimsContainerStyled = styled.div`
  height: fit-content;
  background: #fff;
  border-radius: 8px;
  min-width: 100%;
  padding-bottom: 8px;
  margin-bottom: 24px;
`;

const RequestClaimsHeaderStyled = styled.div`
  padding: 16px;
  border-bottom: 1px solid #e2e6ea;
  & > h1 {
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    color: #0e141d;
  }

  & > h2 {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #494c66;
  }
`;

const RequestClaimsContentStyled = styled.div`
  align-items: end;
  padding: 24px 16px 8px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 8px;
  max-width: 400px;
  margin: auto;
`;

const RequestClaimsSkeletonStyled = styled.div`
  background-color: #e2e6ea;
  height: auto;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  background: linear-gradient(90deg, #e2e6ea 0%, #fff 40% , #e2e6ea 60% );
  background-size: 200% 100%;
  background-position: 100% 0;
  animation: load 2s infinite;
  
  @keyframes load {
    100% {
      background-position: -100% 0;
    }
  }
  
  }
`;

const SkeletonTitle = styled(RequestClaimsSkeletonStyled)`
  height: 20px;
  max-width: 221px;
  margin-bottom: 4px;
`;

const SkeletonSubtitle = styled(RequestClaimsSkeletonStyled)`
  height: 18px;
  max-width: 345px;
`;

const SkeletonActionButton = styled(RequestClaimsSkeletonStyled)`
  height: 100px;
  @media (min-width: 769px) {
    min-width: 128px;
  }
`;

const SkeletonRequestClaimsContainer = styled.div`
  padding: 24px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding: 8px;
`;

const SkeletonMoreText = styled(RequestClaimsSkeletonStyled)`
  height: 18px;
  width: 88px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SkeletonMoreIcon = styled(RequestClaimsSkeletonStyled)`
  width: 24px;
  height: 24px;
  padding: 8px;
  align-items: center;
  margin-left: 12px;
  border-radius: 12px;
`;

const SeeMoreButtonStyled = styled.div`
  margin: auto;
  font-size: 14px;
  text-transform: none;
  color: #4d008c;
  display: flex;
  width: 278px;
  height: 50px;
  padding: 16px 40px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  cursor: pointer;
`;

const ButtonHandleStyled = styled.span`
  width: 24px;
  height: 24px;
`;

const IframeStyled = styled.div`
  & > iframe {
    width: 100%;
    height: ${({ heightIframe }) => heightIframe}px;
  }
`;

export {
  RequestClaimsContainerStyled,
  RequestClaimsHeaderStyled,
  RequestClaimsContentStyled,
  SkeletonTitle,
  SkeletonSubtitle,
  SkeletonActionButton,
  SkeletonRequestClaimsContainer,
  SkeletonMoreText,
  SkeletonMoreIcon,
  SeeMoreButtonStyled,
  ButtonHandleStyled,
  IframeStyled,
};
